export default "__VITE_ASSET__DU8IkzR2__"